export const FullImage = ({
  imageUrl,
  alt,
  fetchPriority = 'auto',
  objectFit = 'cover',
  srcSet,
  sizes,
  width,
  height,
}: FullImageProps) => {
  const loading = fetchPriority === 'high' ? 'eager' : fetchPriority === 'low' ? 'lazy' : undefined

  return (
    <img
      src={imageUrl}
      srcSet={srcSet}
      sizes={sizes}
      width={width}
      height={height}
      alt={alt}
      className={`w-full h-full object-${objectFit}`}
      fetchPriority={fetchPriority}
      loading={loading}
      decoding="async"
    />
  )
}

interface FullImageProps {
  imageUrl: string
  alt?: string
  fetchPriority?: 'auto' | 'low' | 'high'
  objectFit?: 'cover' | 'contain'
  srcSet?: string
  sizes?: string
  width?: number
  height?: number
}
